import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


import { ProductService, ToasterService } from '../../_services';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {
  productId:string;
  productData:any;
  priceGKC:string;
  constructor(
    private _product : ProductService,
    private _toaster : ToasterService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.productId = params.get("id");
    })
    this.getProductDetailById();
  }

  getProductDetailById(){
    this.spinner.show();
    this._product.getProductDetailById(this.productId).subscribe(result=>{
      this.productData = result;
      // Get data from item_private collection
      this._product.getProductGKCPriceById(this.productId).subscribe(result1=>{
        this.priceGKC = result1 && result1.length>0 && result1[0].payload.doc.data().price_gkc ? result1[0].payload.doc.data().price_gkc : '';
      }, err=>{
        this._toaster.showError("Something went wrong", "Error"); 
      })
      // console.log(this.productData,'this.productData!!!');
    this.spinner.hide();
    },err=>{
      this._toaster.showError("Something went wrong", "Error"); 
    })
  }

}
